/**
 * Form-cache IndexedDB local key／origin 正規化。
 * key = `{normalizedApiOrigin}::{userId}::{scope}`
 * @see docs/API_SYSTEM_FORM_CACHE.md
 */

/**
 * @param {string} apiOrigin — 絕對 URL 或相對 path（如 `/api`）
 * @returns {string}
 */
export function normalizeApiOrigin(apiOrigin) {
  const raw = String(apiOrigin ?? '').trim();
  if (!raw) {
    return '';
  }

  if (/^https?:\/\//i.test(raw)) {
    try {
      const url = new URL(raw);
      const path = url.pathname.replace(/\/+$/, '') || '';
      return `${url.protocol}//${url.host}${path}`;
    } catch {
      return raw.replace(/\/+$/, '');
    }
  }

  const path = raw.startsWith('/') ? raw.replace(/\/+$/, '') : `/${raw.replace(/\/+$/, '')}`;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${path || '/api'}`;
  }
  return path || '/api';
}

/**
 * @param {{ apiOrigin: string, userId: string, scope: string }} params
 * @returns {string}
 */
export function buildLocalFormCacheKey({ apiOrigin, userId, scope }) {
  const origin = normalizeApiOrigin(apiOrigin);
  const actor = String(userId ?? '').trim();
  const scopeKey = String(scope ?? '').trim();
  return `${origin}::${actor}::${scopeKey}`;
}
